// Ghost adds its host as a referral parameter to outbound links. Preserve the
// guide's original destinations when serving it on the main ShuttleOps site.
export function guideContent(post) {
  return { ...post, html: post.html.replace(/href="([^"]+)"/g, (attribute, href) => {
    if (!/^https?:\/\//.test(href)) return attribute;
    const url = new URL(href.replaceAll('&amp;', '&'));
    if (url.searchParams.get('ref') !== 'pulse.shuttleops.com') return attribute;
    url.searchParams.delete('ref');
    return `href="${url.href.replaceAll('&', '&amp;')}"`;
  }) };
}
